import { useContext } from 'react';
import { Box } from '@mantine/core';
import EmailHistoryList from '../../Organismns/Message/EmailHistoryList';
import PaginationNav from '../../Molecules/Navigation/PaginationNav';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import EmailsListHeader from '../../Organismns/Message/EmailsListHeader';

const EmailMasterDetail = () => {
  const { pageNumber, totalCount, pageCount, setPageNumber, messages, isBookitupScope, loading } =
    useContext(EmailBoxContext);
  const emptyBox = messages.length === 0;

  return (
    <Box>
      <EmailsListHeader desktop />
      <EmailHistoryList />
      {!emptyBox && (
        <Box>
          <PaginationNav
            pageSize={10}
            pageNumber={pageNumber}
            totalCount={totalCount}
            totalPages={pageCount}
            onChange={(newPageNumber) => setPageNumber(newPageNumber - 1)}
            entityName="Nachricht"
            disabled={!isBookitupScope && loading}
          />
        </Box>
      )}
    </Box>
  );
};

export default EmailMasterDetail;
